import { render, staticRenderFns } from "./AddDocumentRow.vue?vue&type=template&id=cadcde3a&scoped=true"
import script from "./AddDocumentRow.vue?vue&type=script&lang=js"
export * from "./AddDocumentRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadcde3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cadcde3a')) {
      api.createRecord('cadcde3a', component.options)
    } else {
      api.reload('cadcde3a', component.options)
    }
    module.hot.accept("./AddDocumentRow.vue?vue&type=template&id=cadcde3a&scoped=true", function () {
      api.rerender('cadcde3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/AddDocumentRow.vue"
export default component.exports